module.exports = __webpack_public_path__ + "static/media/download-conv2.01b63d3d.svg";